<template>
  <div class="accordion">
    <div class="accordion-item">
      <div class="accordion-title" @click="toggleAccordion(0)">
        House rules
        <span :class="{ 'accordion-icon': true, 'is-active': items[0].isActive }">
          <span v-if="!items[0].isActive">+</span>
          <span v-else>-</span>
        </span>
      </div>
      <div class="accordion-content" :class="{ 'is-active': items[0].isActive }">
        <house-rules/>
      </div>
    </div>
    <div class="accordion-item">
      <div class="accordion-title" @click="toggleAccordion(1)">
        Sport Rules
        <span :class="{ 'accordion-icon': true, 'is-active': items[1].isActive }">
          <span v-if="!items[1].isActive">+</span>
          <span v-else>-</span>
        </span>
      </div>
      <div class="accordion-content" :class="{ 'is-active': items[1].isActive }">
        <sport-rules/>
      </div>
    </div>
    <div class="accordion-item">
      <div class="accordion-title" @click="toggleAccordion(2)">
        Casino Rules
        <span :class="{ 'accordion-icon': true, 'is-active': items[2].isActive }">
          <span v-if="!items[2].isActive">+</span>
          <span v-else>-</span>
        </span>
      </div>
      <div class="accordion-content" :class="{ 'is-active': items[2].isActive }">
        <casino-rules/>
      </div>
    </div>
  </div>
</template>

<script>
import HouseRules from "@/components/house-rules.vue"
import SportRules from "@/pages/sports-rules.vue"
import CasinoRules from "@/components/casino-rules.vue"

export default {
  name: "AccordionComponent",
  components: {
    HouseRules,
    SportRules,
    CasinoRules
  },
  data() {
    return {
      items: [
        {
          isActive: false,
        },
        {
          isActive: false,
        },
        {
          isActive: false,
        },
      ],
    };
  },
  methods: {
    toggleAccordion(index) {
      this.closeAllAccordions(index);
      this.items[index].isActive = !this.items[index].isActive;
    },
    closeAllAccordions(activeIndex) {
      this.items.forEach((item, index) => {
        if (index !== activeIndex) {
          item.isActive = false;
        }
      });
    },
  },
};
</script>